import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import NotFound from "./components/utilComponents/notFound";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { FaMicrosoft } from "react-icons/fa";
import { SiOkta } from "react-icons/si";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import {
  getAuthProvider,
  setAuthProvider,
} from "./services/authProvider";

/* =====================================================
 * PROVIDER SELECTION SCREEN
 * ===================================================== */
// const ProviderSelector = () => {
//   const handleSelect = (provider) => {
//     setAuthProvider(provider);
//     window.location.reload(); // REQUIRED for redirect auth
//   };

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "flex-start",
//         flexDirection: "column",
//         paddingTop: "5rem",
//         backgroundColor: "#ffffff",
//       }}
//     >
//       <div className="provider-container">
//         <h4 className="mb-4 text-center">Log in to your account</h4>
//         <button className="provider-btn" onClick={() => handleSelect("azure")}>
//           <FaMicrosoft size={20} style={{ marginRight: 12 }} />
//           Login using Microsoft Azure
//         </button>

//         <button className="provider-btn" onClick={() => handleSelect("okta")}>
//           <SiOkta size={20} style={{ marginRight: 12 }} />
//           Continue with Okta
//         </button>
//       </div>
//     </div>



//   );
// };

/* =====================================================
 * ROOT RENDER
 * ===================================================== */
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      
      {/* <Routes>
        {!getAuthProvider() ? (
          <Route path="*" element={<ProviderSelector />} />
        ) : (
          <>
            <Route path="/" element={<App />} />
            <Route path="*" element={<NotFound />} />
          </>
        )}
      </Routes> */}

      <Routes>
        <Route path="/" element={<App />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
